import { Alert, AlertProps, AlertTitle, Typography, Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'
import { User } from '../types'

export interface UserEmailNotificationsDisabledWarningAlertProps extends Omit<
  AlertProps,
  'children' | 'severity'
> {
  user: User
}

export default function UserEmailNotificationsDisabledWarningAlert({
  user,
  ...props
}: UserEmailNotificationsDisabledWarningAlertProps) {
  /**
   * The translate function.
   */
  const { t } = useTranslation('common')

  /**
   * Indicates if the current user has email notifications enabled.
   */
  const emailNotificationsEnabled = user.notificationsByEmail

  return (
    <>
      {!emailNotificationsEnabled && (
        <Alert severity="warning" {...props}>
          <AlertTitle>{t('emailNotificationsDisabled')}</AlertTitle>
          <Typography>{t('emailNotificationsDisabledWarning')}</Typography>
          <Button
            component={NavLink}
            to={`/users/${user.id}#notifications`}
            variant="outlined"
            color="warning"
            size="small"
            sx={{ mt: 2 }}
          >
            {t('goToNotificationSettings')}
          </Button>
        </Alert>
      )}
    </>
  )
}
